import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Container,
  FormControlLabel,
  Checkbox,
  Grid,
  Link,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import "./Login.css";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../axiosInstance";
import { getOrCreateDeviceId } from "../deviceId";
import { toast, ToastContainer } from "react-toastify";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { loadPermissions } from "../permissions";
import { useAuth } from "./access/AuthContext";

const LoginForm = ({ onSwitchToSignup, onSwitchToLogin }) => {
  const { setUser } = useAuth();
  const { setToken } = useAuth();
  const { setRole } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const validate = () => {
    let tempErrors = {};

    if (!email) {
      tempErrors.email = "Email is required";
    } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
      tempErrors.email = "Email is not valid";
    }

    if (!password) {
      tempErrors.password = "Password is required";
    } else if (password.length < 8) {
      tempErrors.password = "Password must be at least 8 characters long";
    }

    setError(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsLoading(true);

    const userData = {
      email: email,
      password: password,
      deviceId: getOrCreateDeviceId(),
    };
    api
      .post("/login", userData, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then(async (response) => {
        if (response.status === 200) {
          localStorage.setItem("token", response.data.token);
          toast.success("Login Successfully !", {
            autoClose: 2000,
          });
          const { token, user, expiresIn } = response.data;
          //  Store both token and user in localStorage
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("expiresIn", expiresIn);
          localStorage.setItem("loginTime", Date.now());
          // localStorage.setItem("roles");

          // Update context
          setUser(user);

          // Load permissions
          await loadPermissions();

          // navigate("/booklist", {  
          //   state: { roles: response.data.user },
          // });
          setTimeout(() => {
            navigate("/auth-landing", { replace: true });
          }, 500);

          setIsLoading(false);
        } else {
          localStorage.removeItem("token");
          toast.error("Invalid login details. Please check and try again!", {
            autoClose: 3000,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          toast.error(error.response.data.message, {
            autoClose: 3000,
          });
          setIsLoading(false);
          console.log("Unauthorized:", error.response.data.message);
        } else {
          toast.error(error.response.data.message, {
            autoClose: 3000,
          });
          console.error("Other error:", error);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <Container component="main" maxWidth="xs" className="loginpage">
        <form onSubmit={handleSubmit} className="login">
          <Typography variant="h6">Login now</Typography>
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password}
            fullWidth
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    color="primary"
                  />
                }
                label="Remember Me"
              />
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                Forgot Password?
              </Link>
            </Grid>
          </Grid>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            className="submitButton"
            // onClick={onSwitchToLogin}
          >
            {isLoading ? "Loading..." : "Login"}
          </Button>
          <Typography align="center" style={{ marginTop: "20px" }}>
            Not registered yet? Create an account{" "}
            <Link component={RouterLink} onClick={onSwitchToSignup}>
              Signup
            </Link>
          </Typography>
        </form>
      </Container>
    </>
  );
};

export default LoginForm;
